import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from '@auth/components/login/login.component';
import { SignUpMobilePhoneComponent } from '@auth/components/signup-mobile-phone/signup-mobile-phone.component';
import { MsalRedirectComponent } from '@azure/msal-angular';
import { DefaultLayoutComponent } from '@base/components/layout/default-layout/default-layout.component';
import { AuthRoutes } from '@core/constants/routes.const';
import { GuestGuardService } from '@core/services/guest-guard.service';
import { B2cSigninPhoneComponent } from './components/b2c-signin/b2c-signin-phone.component';
import { B2cSigninComponent } from './components/b2c-signin/b2c-signin.component';
import { LoginPhoneComponent } from './components/login-phone/login-phone.component';
import { SignUpMobilePhoneB2CComponent } from './components/signup-mobile-phone-b2c/signup-mobile-phone-b2c.component';
import { LoginMainComponent } from './login.main/login.main.component';

const routes: Routes = [
  {
    path: AuthRoutes.B2CSignin,
    component: B2cSigninComponent,
  },
  {
    path: AuthRoutes.B2CSigninPhone,
    component: B2cSigninPhoneComponent,
  },
  {
    path: AuthRoutes.B2CSigninTarget,
    component: MsalRedirectComponent,
  },
  {
    path: AuthRoutes.SignUpPhoneNumberB2C,
    component: SignUpMobilePhoneB2CComponent,
  },
  {
    path: AuthRoutes.SignUpPhoneNumberB2C,
    component: SignUpMobilePhoneB2CComponent,
  },
  {
    path: AuthRoutes.Login,
    component: DefaultLayoutComponent,
    children: [
      {
        path: '',
        component: LoginComponent,
        canActivate: [GuestGuardService],
        data: {
          title: $localize`Customer account login`,
          description: $localize`Customer account login - Description`,
        },
      },
    ],
  },
  {
    path: AuthRoutes.LoginMain,
    component: DefaultLayoutComponent,
    children: [
      {
        path: '',
        component: LoginMainComponent,
        canActivate: [GuestGuardService],
        data: {
          title: $localize`Customer account login options`,
          description: $localize`Customer account login options- Description`,
        },
      },
    ],
  },
  {
    path: AuthRoutes.LoginViaPhone,
    component: DefaultLayoutComponent,
    children: [
      {
        path: '',
        component: LoginPhoneComponent,
        canActivate: [GuestGuardService],
        data: {
          title: $localize`Customer account phone login`,
          description: $localize`Customer account phone login - Description`,
        },
      },
    ],
  },
  {
    path: AuthRoutes.VerifyPhone,
    component: DefaultLayoutComponent,
    children: [
      {
        path: '',
        component: SignUpMobilePhoneComponent,
        canActivate: [GuestGuardService],
        data: {
          title: $localize`Customer account phone login`,
          description: $localize`Customer account phone login - Description`,
        },
      },
    ],
  },
  {
    path: AuthRoutes.VerifyPhone,
    component: DefaultLayoutComponent,
    children: [
      {
        path: '',
        component: SignUpMobilePhoneComponent,
        canActivate: [GuestGuardService],
        data: {
          title: $localize`Customer account phone login`,
          description: $localize`Customer account phone login - Description`,
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
